export const AuditTrailLoadState = {
  IDLE: 'idle',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error',
};

export const AUDIT_TRAIL_TITLE = 'Audit trail';

export const AUDIT_TRAIL_EMPTY_MESSAGE = 'No audit events yet';

export const AUDIT_SKELETON_ROWS = 3;
